import { render, staticRenderFns } from "./PatientPanelActions.vue?vue&type=template&id=40f7cb3c&scoped=true"
import script from "./PatientPanelActions.vue?vue&type=script&lang=js"
export * from "./PatientPanelActions.vue?vue&type=script&lang=js"
import style0 from "./PatientPanelActions.vue?vue&type=style&index=0&id=40f7cb3c&prod&lang=scss&scoped=true"
import style1 from "./PatientPanelActions.vue?vue&type=style&index=1&id=40f7cb3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7cb3c",
  null
  
)

export default component.exports